module.exports = __webpack_public_path__ + "static/media/taxi.81d4c00f.svg";